import { useTranslation } from 'react-i18next';

import { PostCreationRoute } from '@/features/post-editor/navigation/postCreationRoute';
import { PostEditorRoute } from '@/features/post-editor/navigation/postEditorRoute';
import { PostCreationHomeScreen } from '@/features/post-editor/screens/PostCreationHomeScreen';
import { PostCreationRegionScreen } from '@/features/post-editor/screens/PostCreationRegionScreen';
import { PostEditorScreen } from '@/features/post-editor/screens/PostEditorScreen';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { AppStack } from '@/navigation/stacks/appStack';

export const usePostEditorRouting = () => {
  const { t } = useTranslation(LocalizationNameSpace.POST_EDITOR, {
    keyPrefix: 'routes'
  });

  return {
    postEditorScreens: [
      <AppStack.Screen
        key={PostEditorRoute.PostEditor}
        name={PostEditorRoute.PostEditor}
        component={PostEditorScreen}
        options={{
          title: t(PostEditorRoute.PostEditor),
          headerShown: true,
          presentation: 'containedModal',
          animation: 'fade'
        }}
      />,
      <AppStack.Screen
        key={PostCreationRoute.PostCreationHome}
        name={PostCreationRoute.PostCreationHome}
        component={PostCreationHomeScreen}
        options={{
          presentation: 'containedModal',
          animation: 'fade'
        }}
      />,
      <AppStack.Screen
        key={PostCreationRoute.PostCreationRegion}
        name={PostCreationRoute.PostCreationRegion}
        component={PostCreationRegionScreen}
        options={{
          presentation: 'containedModal',
          animation: 'fade'
        }}
      />
    ]
  };
};
